import { FC } from 'react';
import { Link, LinkProps } from '@mui/material';

import useMenu from './useMenu';

export type MenuLinkProps = Omit<LinkProps<'button'>, 'component' | 'href' | 'ref'>;

export const MenuLink: FC<MenuLinkProps> = ({ children, onClick, ...rest }) => {
  const { onOpen } = useMenu();

  return (
    <Link
      {...rest}
      component='button'
      onClick={e => {
        onClick?.(e);
        onOpen(e);
      }}
    >
      {children}
    </Link>
  );
};
